export default "__VITE_ASSET__DgITh2TE__"